import React from 'react';
import styled from 'styled-components';
import ic_booking from '../BookingOnlineV2/assets/booking.svg';
import ic_valid from '../BookingOnlineV2/assets/valid.svg';
import clsx from 'clsx';
import { Form } from 'antd';
const img_valid = <img src={ic_valid} alt="ic_valid" style={{ height: 14, width: 10 }} />;
type Props = {
  step?: 'customer' | 'date_staff' | 'time_slot' | 'time' | 'service' | 'staff' | 'review' | 'success';
  valid?: boolean;
};
export const titleRef = React.createRef<HTMLDivElement>();
const HeaderStep = ({ step, valid }: Props) => {
  const form = Form.useFormInstance();
  const DATE_STAFF_VALID = Form.useWatch('DATE_STAFF_VALID', form);
  const TIME_SLOT_VALID = Form.useWatch('TIME_SLOT_VALID', form);
  const SERVICE_VALID = Form.useWatch('SERVICE_VALID', form);
  return (
    <Container>
      <Title ref={titleRef}>
        <span>Booking Online</span>
        <img src={ic_booking} alt="ic_booking" />
      </Title>
      <Tabs>
        <div className={clsx('tab-item', step === 'date_staff' && 'active', DATE_STAFF_VALID && 'valid')}>
          {DATE_STAFF_VALID && img_valid}
          <span>Staff</span>
        </div>
        <div className={clsx('tab-item', step === 'service' && 'active', SERVICE_VALID && 'valid')}>
          {SERVICE_VALID && img_valid}
          <span>Service</span>
        </div>
        <div className={clsx('tab-item', step === 'time_slot' && 'active', TIME_SLOT_VALID && 'valid')}>
          {TIME_SLOT_VALID && img_valid}
          <span>Time</span>
        </div>
        <div className={clsx('tab-item', step === 'review' && 'active', valid && 'valid')}>
          {valid && img_valid}
          <span>Review</span>
        </div>
      </Tabs>
    </Container>
  );
};

export default HeaderStep;

const Tabs = styled.div`
display: flex;
align-items: flex-start;
gap: 4px;
align-self: stretch;

  .tab-item {
    display: flex;
    flex: 1;
    padding: 8px 2px 16px 2px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    border-bottom: 4px solid #CCD4DC;
    transition: 0.3s;
    span {
      color: #1D2129;
      font-family: Poppins;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }

    &.active {
      border-bottom: 4px solid #2463EB;
      span {
        color: #2463EB;
      }
    }
    &.valid {
      span {
        color: #2463EB;
      }
    }
  }
`;
const Title = styled.div`
display: flex;
padding: 8px 0;
justify-content: center;
align-items: center;
gap: 10px;
align-self: stretch;
span {
  height: 24px;
  flex: 1 0 0;
  color: #1D2129;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
}
img {
  width: 48px;
  height: 48px;
  aspect-ratio: 1/1;
}
`;
const Container = styled.div`
display: flex;
padding: 0 16px 16px 16px;
flex-direction: column;
align-items: flex-start;
align-self: stretch;
background: #F5F5F5;
`;

